import { useGlobal } from '../../state';
import { Code, CodeBlock } from '../code';

export const ApiKey = () => {
  const { apiKey } = useGlobal();

  return <CodeBlock language="text" code={apiKey} inline copy hideCode />;
};
